<template>
  <div
    id="artificialLag"
    v-if="exam_details.is_simulation === 1 && exam_details.artificial_lag === 1"
  >

    <h2>Artificial Lag Settings</h2>

    <p>
      Normally, you can instantly switch between questions in our system, while in your actual exam,
      it takes a while to load a new question. To make sure you’re practicing with a realistic
      setup, you can enable artificial lags here:
    </p>

    <div>
      <div>
        <label for="normal_lag">
          <input id="normal_lag" type="radio" v-model="artificial_type" value="normal" />
          <span>Add a normal artificial lag (recommended)</span>
        </label>
      </div>
      <div>
        <label for="large_lag">
          <input id="large_lag" type="radio" v-model="artificial_type" value="large" />
          <span>Add a long artificial lag (for slower connections)</span>
        </label>
      </div>
      <div>
        <label for="no_lag">
          <input id="no_lag" type="radio" v-model="artificial_type" value="no_lag" />
          <span>Add no lag</span>
        </label>
      </div>
    </div>


  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardArtificialLag",
  data() {
    return {
      type: "",
      showArtificialForm: false
    };
  },
  computed: {
    artificial_type: {
      get() {
        return this.$store.state.artificial_type;
      },
      set(value) {
        this.$store.commit("SET_ARTIFICIAL_TYPE", value);
      }
    },
    ...mapState("exam", ["exam_details"])
  }
};
</script>
